<template>
  <div class="jdc">
    <fieldset :disabled="loading" class="jdc-fieldset">
      <label for="declineDescription" class="jdc-label"
        >Lütfen red gerekçenizi belirtiniz:</label
      >
      <textarea
        id="declineDescription"
        ref="description"
        v-model="description"
        class="jdc-textarea"
        required
        rows="6"
      ></textarea>
      <div class="jdc-bar">
        <div class="jdc-bar-inner" role="group">
          <button
            type="button"
            class="jdc-btn jdc-btn-outline"
            @click="$emit('cancel')"
          >
            Vazgeç
          </button>
          <button type="button" class="jdc-btn jdc-btn-danger" @click="decline">
            Reddet
          </button>
        </div>
      </div>
    </fieldset>
  </div>
</template>
<script>
export default {
  data() {
    return {
      description: "",
      loading: false
    };
  },
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  mounted() {
    this.$refs.description.focus();
  },
  methods: {
    decline() {
      if (!this.description) {
        this.$izonayAlert("Lütfen red gerekçenizi belirtiniz.").then(() => {
          setTimeout(() => {
            this.$refs.description.focus();
          }, 500);
        })
        return;
      } else {
        this.loading = true;
        this.$emit("decline", this.description);
      }
    }
  }
};
</script>
<style scoped>
/* Voya: iş reddetme */
.jdc {
  padding-bottom: calc(env(safe-area-inset-bottom, 0px) + 96px);
  font-family: 'Poppins', Avenir, Helvetica, Arial, sans-serif;
  color: #092154;
}

.jdc-fieldset {
  min-width: 0;
  margin: 0;
  padding: 0;
  border: 0;
}

.jdc-label {
  display: block;
  margin: 12px 0 8px 0;
  font-weight: 500;
  font-size: 14px;
  line-height: 140%;
  color: #333333;
}

.jdc-textarea {
  display: block;
  box-sizing: border-box;
  width: 100%;
  padding: 12px 14px;
  border: 1px solid #E6E9EE;
  border-radius: 8px;
  outline: none;
  background-color: #ffffff;
  font-family: inherit;
  /* iOS'ta odaklanınca sayfanın yakınlaşmaması için 16px */
  font-size: 16px;
  line-height: 150%;
  color: #333333;
  resize: none;
}

.jdc-textarea:focus {
  border-color: #182F5E;
  box-shadow: 0 0 0 3px rgba(24, 47, 94, 0.12);
}

.jdc-textarea:disabled {
  background-color: #F5F7FA;
  color: #808080;
}

.jdc-bar {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1000;
  box-sizing: border-box;
  padding: 12px 16px calc(env(safe-area-inset-bottom, 0px) + 12px) 16px;
  border-top: 1px solid #EFEFEF;
  background-color: #ffffff;
  box-shadow: 0 -4px 16px rgba(9, 33, 84, 0.08);
}

.jdc-bar-inner {
  display: flex;
  gap: 8px;
  max-width: 560px;
  margin: 0 auto;
}

.jdc-btn {
  flex: 1 1 0;
  height: 48px;
  padding: 0 16px;
  border: 1px solid transparent;
  border-radius: 8px;
  font-family: inherit;
  font-weight: 600;
  font-size: 15px;
  white-space: nowrap;
}

.jdc-btn:disabled {
  opacity: 0.6;
}

.jdc-btn-outline {
  border-color: #182F5E;
  background-color: #ffffff;
  color: #182F5E;
}

.jdc-btn-outline:active {
  background-color: #F4F6FA;
}

.jdc-btn-danger {
  background-color: #DC3545;
  color: #ffffff;
}

.jdc-btn-danger:active {
  background-color: #BB2D3B;
}
</style>
